import { Injectable } from '@angular/core';
export const DE_LOCAL_KEYS = {
  filterCacheKey: 'DE_CACHE_FILTER_KEY',
  searchCacheKey: 'DE_CACHE_SEARCH_KEY',
};

@Injectable()
export class BrowserStorageService {
  constructor() { }

  set(key: string, data: any, storage: Storage = null): void {
    try {
      if (storage) {
        storage.setItem(key, JSON.stringify(data));
      } else {
        localStorage.setItem(key, JSON.stringify(data));
      }
    } catch (e) {
      console.error('Error saving to localStorage', e);
    }
  }

  get(key: string, storage: Storage = null) {
    try {
      if (storage) {
        return JSON.parse(storage.getItem(key));
      } else {
        return JSON.parse(localStorage.getItem(key));
      }
    } catch (e) {
      console.error('Error getting data from localStorage', e);
      return null;
    }
  }

  getByKey<T>(key: string) {
    return this.get(key) as T;
  }
  remove(key: string, storage: Storage = null) {
    try {
      if (storage) {
        storage.removeItem(key);
      } else {
        return JSON.parse(localStorage.getItem(key));
      }
    } catch (e) {
      console.error('Error deleting to localStorage', e);
    }
  }
}
